import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useHideStats = (): IGlobalStore['hideStats'] => {
  return useSelector((store: IReducerStore) => store.global.hideStats);
};
